import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { WebUserService } from '../../../../services/webuser.service';
import { Location } from '../../../../models/location';
import { LocationService } from '../../../../services/location.service';
import { CompanyService } from '../../../../services/company.service';

@Component({
  selector: 'app-webusers-manage',
  templateUrl: './webusers-manage.component.html',
  styleUrls: ['./webusers-manage.component.scss']
})
export class WebusersManageComponent implements OnInit {

  id: string = null;
  firstname: string = "";
  lastname: string = "";
  email: string = "";
  password: string = "";
  password2: string = "";
  userId: number = 0;
  companyId: number = undefined;
  locationId: number = undefined;
  base64Signature: string = null;
  title: string = "";
  selectedLocations: Location[];
  locationList: Location[];
  userids;
  constructor(private webUserService: WebUserService, private locationService: LocationService,
    private companyService: CompanyService,
    private router: Router, private route: ActivatedRoute, private snotifyService: SnotifyService) { }

  ngOnInit(): void {
    this.locationService.getAll().then((data) => {
      this.locationList = data;
      //console.log(data);
      if (this.userids != undefined) {
        for (var i = 0; i < this.userids.length; i++) {
          var _id = this.userids[i];
          this.addLocation(_id);
        }
      }
    });

    this.route.paramMap.subscribe((paramsMap) => {
      var id = paramsMap.get("id");
      //console.log(id);
      if (id != null) {
        
        this.webUserService.get(id).then((user) => {
          //console.log(user);
          this.id = user.id;
          this.firstname = user.firstname;
          this.lastname = user.lastname;
          this.email = user.email;
          this.password = user.password;
          this.password2 = user.password2
          this.title = user.title;
          this.userId = user.userProfileId;
          this.companyId = user.companyId;
          this.locationId = user.locationId;
          this.userids = user.locationIds;
          if (this.locationList != undefined) {
            for (var i = 0; i < user.locationIds.length; i++) {
              var _id = user.locationIds[i];
              this.addLocation(_id);
            }
          }
       
        });
      }
    });
  }

  back() {
    this.router.navigate(['users']);
  }

  validate() {
    if (this.firstname == null || this.firstname == "") {
      this.snotifyService.error("Enter firstname");
      //alert("Enter firstname");
      return false;
    }

    if (this.lastname == null || this.lastname == "") {
      this.snotifyService.error("Enter lastname");
      //alert("Enter lastname");
      return false;
    }

    if ((this.password == null || this.password == "") && (this.password2 != null && this.password2 != "")) {
      this.snotifyService.error("Enter password");
      //alert("Enter password");
      return false;
    }

    if ((this.password != null && this.password != "") && (this.password2 == null || this.password2 == "")) {
      this.snotifyService.error("Enter password");
      //alert("Enter password");
      return false;
    }

    if ((this.password != null && this.password != "") && (this.password2 != null && this.password2 != "") && (this.password != this.password2)) {
      this.snotifyService.error("Passwords do not match");
      //alert("Passwords do not match");
      return false;
    }
    
    if ((this.userId == null || this.userId <= 0) && (this.companyId == null || this.companyId <= 0)) {
      this.snotifyService.error("Please Select a Company");
      //alert("Enter lastname");
      return false;
    }

    return true;
  }

  async save() {
    if (!this.validate()) {
      return;
    }

    var user = {
      id: this.id,
      firstname: this.firstname,
      lastname: this.lastname,
      password: this.password,
      email: this.email,
      userProfileId: this.userId,
      companyId: this.companyId,
      locationId: this.locationId,
      locationIds: []
    };

    for (var i = 0; i < this.selectedLocations.length; i++) {
      user.locationIds.push(this.selectedLocations[i].id);
    }
    if (this.id == null)
      await this.webUserService.add(user);
    else
      await this.webUserService.update(user);

    this.router.navigate(['users']);
  }
  addLocation(_id) {
    //console.log("addLocation");
    if (this.selectedLocations == undefined)
      this.selectedLocations = [];

    var idx = -1;
    //console.log("Add Location");
    //console.log(_id);
    for (var i = 0; i < this.locationList.length; i++) {
      var loc = this.locationList[i];

      if (loc.id == _id) {
      ////console.log(loc.id);
        for (var ii = 0; ii < this.selectedLocations.length; ii++) {
          var locc = this.selectedLocations[ii];
          if (locc.id == _id)
            idx = ii;
        }

        if (idx < 0) {
          //console.log(loc);
          this.selectedLocations.push(loc);
        }

      }
    }
    //console.log(this.selectedLocations);
  }

  removeLocation(_id) {
    var idx = -1;
    for (var i = 0; i < this.selectedLocations.length; i++) {
      var loc = this.selectedLocations[i];
      if (loc.id == _id)
        idx = i;
    }

    if (idx >= 0) {
      this.selectedLocations.splice(idx,1)
    }
  }
  addAllLocations() {
    this.companyService.get(this.companyId).then((data) => {
      //console.log(data);
      var locs = this.locationList.filter(c => {
        return c.contract_No == data.contract_No;
      });
      for (var i = 0; i < locs.length; i++) {
        var loc = locs[i];
        this.addLocation(loc.id);
      }

    });

  
  }
  async delete() {
    await this.webUserService.delete(this.id);
    this.router.navigate(['users']);
  }

  setUserProfile(user) {
    //console.log(user.userTypeId);
    if (user.userTypeId != null) {
      this.userId = user.userTypeId;
      this.companyId = undefined;
    }
  }
  setCompanyId(value) {
    if (value == undefined)
      this.companyId = undefined;
    else
      this.companyId = value.id;

    this.selectedLocations = [];
  }

  onLocationChange(value) {
    if (value == undefined)
      this.locationId = undefined;
    else
      this.locationId = value.id;

  }

}
